/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, memo, useEffect } from "react";
import MenuLoyalty from "./Components/MenuLoyalty";
import Loyalty from "./Components/Loyalty";

import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { getCRMShopInfoDetail } from "store/actions/HomePageAction";
import { getCRMLevelInfo } from "store/actions/InfoLoyaltyPageAction";

const InfoLoyalty = memo(props => {
	const { infoShop, getCRMShopInfoDetail, getCRMLevelInfo, dataInfoLoyalty } =
		props;

	useEffect(() => {
		getCRMShopInfoDetail();
		getCRMLevelInfo();
	}, []);

	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const menuLoyalty = Object.keys(dataInfoLoyalty)
		?.map(loyalty => {
			return {
				...dataInfoLoyalty[loyalty],
				sales: dataInfoLoyalty[loyalty]?.achievedSales,
				label: dataInfoLoyalty[loyalty]?.levelName,
				bonus: `${dataInfoLoyalty[loyalty]?.rewardLevel}%`,
				type: dataInfoLoyalty[loyalty]?.level,
				component: (
					<Loyalty
						properties={{
							...dataInfoLoyalty[loyalty],
							sales: dataInfoLoyalty[loyalty]?.achievedSales,
							logo: dataInfoLoyalty[loyalty]?.logo,
							icon: dataInfoLoyalty[loyalty]?.icon,
							bonus: `${dataInfoLoyalty[loyalty]?.rewardLevel}%`,
							numOfWeekPurchase:
								dataInfoLoyalty[loyalty]?.numOfWeekPurchase
						}}
						dataInfoLoyalty={dataInfoLoyalty}
						infoShop={infoShop}
						details={true}
						bonus={`${dataInfoLoyalty[loyalty]?.rewardLevel}%`}
					/>
				)
			};
		})
		?.sort(function (a, b) {
			return a?.id - b?.id;
		});

	const indexMenu = menuLoyalty?.findIndex(
		loyalty => loyalty.type === infoShop?.crmNextLevel
	);

	useEffect(() => {
		if (indexMenu) {
			setValue(indexMenu);
		} else {
			setValue(0);
		}
	}, [indexMenu]);

	return (
		<Grid>
			<MenuLoyalty
				menuLoyalty={menuLoyalty}
				value={value}
				handleChange={handleChange}
			/>
		</Grid>
	);
});

const mapStateToProps = state => {
	return {
		infoShop: state.homePageReducer.infoShop,
		dataInfoLoyalty: state.infoLoyaltyPageReducer.dataInfoLoyalty
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getCRMShopInfoDetail: data => {
			dispatch(getCRMShopInfoDetail(data));
		},
		getCRMLevelInfo: () => {
			dispatch(getCRMLevelInfo());
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoLoyalty);
